import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: {
    type: 'panel'
  }
} satisfies RecursivePartial<CheckoutConfig['giftCard']>
